module.exports = "/images/Artboard 3 copy 18.svg?4e79139f1cee4ce1351a4b41f995d333";